<template>
  <Loader v-if="loading"/>
  <div v-else-if="!loading" class="py-5 px-3">
    <!-- <v-btn v-if="url" @click="deleteOrder" color="error">Delete measurement-group (can't be undone)</v-btn> -->
    <v-text-field label="Name of measurement group (must be unique)" box v-model="data.name"></v-text-field>
    <v-layout row wrap>
      <template v-for="(item,index) in data.data">
        <measurementCard
          @changeImage="changeImage"
          @deleteField="deleteItem"
          :image="files[Math.abs(length - index)]"
          :item="item"
          :index="index"
          :key="index"
        />
      </template>
    </v-layout>
    <h3 class="mt-5">Add new field:</h3>
    <newField @fieldChange="fileChanged" />
    <v-btn @click="saveChanges" color="info">Save changes</v-btn>
  </div>
</template>

<script>
import newField from "../components/addMeasurementField.vue";
import measurementCard from "../components/measurement-card.vue";
import { deleteFile } from "../mixins/deleteFile.js";
import { uploadTaskPromise } from "../mixins/upload-image.js";
import Loader from "@/components/Loader";
import { db } from "../firebase";
export default {
  data() {
    return {
      data: [],
      length: 0,
      files: [],
      newImages: [],
      url: "",
      loading:false
    };
  },
  components: {
    newField,
    measurementCard,
    Loader
  },
  methods: {
    // TODO: create mixin that deletes items and refactor
    deleteItem(index) {
      this.data.data.splice(index, 1);
      this.files.splice(index, 1);
    },
    fileChanged(item) {
      this.files.push(item.file);
      let { id, label, type, description } = item;
      this.data.data.push({
        id,
        type,
        label,
        description,
        measurementvalue: ""
      });
    },
    saveChanges() {
      this.loading = true;
      if (this.files.length != 0) {
          (async () => {
            const files = this.files;
            for (const [index, file] of files.entries()) {
              const url = await uploadTaskPromise(file);
              this.data.data[index + this.length].url = url; 
              // saving data to firestore
            }
              let data = this.data;
              let newData = this.newMeasurements;
              if(this.url){
                db.collection("measurements")
                .doc(this.url)
                .set({ ...data, ...newData})
                .then(() => {
                  this.loading = false;
                  console.log("sucess");
                })
                .catch(e => {
                  this.loading = false;
                  console.log("erroor", e);
                });
              }
              else{
                db.collection("measurements")
                .add({ ...data, ...newData})
                .then(() => {
                  this.loading = false;
                  console.log("sucess");
                })
                .catch(e => {
                  this.loading = false;
                  console.log("erroor", e);
                });
              }
          })();
      } else {
        let data = this.data;
        let newData = this.newMeasurements;
        if (this.url) {
          db.collection("measurements")
            .doc(this.url)
            .set({ ...data, ...newData })
            .then(() => {
              this.loading = false;
              console.log("sucess");
            })
            .catch(e => {
              this.loading = false;
              console.log("erroor", e);
            });
        } else {
          db.collection("measurements")
            .add({ ...data, ...newData })
            .then(() => {
              this.loading = false;
              console.log("success");
            })
            .catch(e => {
              this.loading = false;
              console.log("error", e);
            });
        }
      }
    },
    deleteOrder() {
      let id = this.$route.params.id;
      db.collection("measurements")
        .doc(id)
        .delete()
        .then(() => {
          this.$router.go(-1);
        })
        .catch(error => {
          console.error("Error removing document: ", error);
        });
    },
    changeImage(e, index) {
      //Delete Existing Image and upload new one
      let file = e.target.files[0];
      let url = this.data.data[index].url;
      let dataobj = this.data;
      deleteFile(url)
        .then(() => {
           (async () => {
             const url = await uploadTaskPromise(file);
             this.data.data[index].url = url;
                db.collection("measurements")
                  .doc(this.url)
                  .set({ ...dataobj })
                  .then(() => {
                    console.log("success");
                  })
                  .catch(e => {
                    console.log("error", e);
                  });
           })()
        })
        .catch(e => {
          throw new Error(e, "error deleting image");
        });
    }
  },
  created() {
    let url = this.$route.params.id;
    this.url = this.$route.params.id;
    if (url == "newmeasurementgroup") {
      this.data = { data: [], name: "" };
      this.url = "";
      return;
    } else {
      db.collection("measurements")
        .doc(url)
        .get()
        .then(docSnapshot => {
          if (docSnapshot.exists) {
            this.data = docSnapshot.data();
            this.length = this.data.data.length;
          } else {
            this.data = { data: [], name: "" };
          }
        })
        .catch(e => {
          console.error(`Error happened: ${e}`);
        });
    }
  }
};
</script>

<style>
.img-measure {
  height: 100px;
  width: 100%;
}
</style>
